module.exports = __webpack_public_path__ + "static/media/Slice4@2x.8105a046.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_147/img/Slice4@2x.png
// module id = 1409
// module chunks = 0